import DepartamentoService from 'src/modules/departamento/departamentoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'DEPARTAMENTO_VIEW';

const departamentoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: departamentoViewActions.FIND_STARTED,
      });

      const record = await DepartamentoService.find(id);

      dispatch({
        type: departamentoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: departamentoViewActions.FIND_ERROR,
      });

      getHistory().push('/departamento');
    }
  },
};

export default departamentoViewActions;
